'use strict';

export default angular
  .module('maestro.services.idle', [])
  .service('IdleService', IdleService)
  .name;

function IdleService($timeout, $log, $window, config, webcore, $rootScope, $q, utils) {

  /**
   * Callbacks for onIdle Event
   * @type {Array<function>}
   */
  let onIdleCallbacks = [];

  /**
   * Callbacks for onActive Event
   * @type {Array<function>}
   */
  let onActiveCallbacks = [];

  /**
   * Idle status
   * @type {string} 'active' or 'idle'
   */
  let idleStatus = 'active'; // or 'idle'

  let idleTimeout;
  let idleTimeoutStartTime; // DateTime of the idle timer start
  let brandedIdleTimeoutConfig;

  let idleTime = config.getConfigByKey('environment.idleTimeout');

  const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
  const ALL_ORGS_LOCAL_STORAGE_KEY = 'Organizations-All';

  angular.extend(this, {
    getIdleStatus: getIdleStatus,
    onIdle: onIdle,
    onActive: onActive
  });

  init();

  function init() {
    $timeout(() => {
      resetIdleTimer();
    }, 1000);

    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click'
    ];
    events.forEach(name => {
      try {
        $window.document.addEventListener(name, () => {
          resetIdleTimer();
        }, true);
      } catch (e) {
        $log.error(e);
      }
    });

    setIdleTimeout();
    webcore.services.auth.onLogin.on(() => {
      setIdleTimeout();
      resetIdleTimer();
    });
    $rootScope.$on('chooseOrganizationEvent', () => {
      $timeout(() => {
        setIdleTimeout();
      }, 1000);
    });

    initBrandedIdleTimeoutConfig();
    resetIdleTimer();
  }

  function resetIdleTimer() {
    let shouldCallOnActiveCbs = false;
    if (idleStatus === 'idle') {
      shouldCallOnActiveCbs = true;
      idleStatus = 'active';
    }
    if (idleTimeout != null) {
      $timeout.cancel(idleTimeout);
    }
    idleTimeoutStartTime = new Date();
    idleTimeout = $timeout(() => {
      idleTimeout = void 0;
      let shouldCallOnIdleCbs = false;
      if (idleStatus === 'active') {
        shouldCallOnIdleCbs = true;
        idleStatus = 'idle';
      }

      // NOTE: Sometimes the timeout may be executed not after the specified time,
      //  but much later due to the browser "putting the tab to sleep".
      //  In this case, the code will be executed later than the scheduled time.
      const overdueTimeMs = (new Date()).getTime() - idleTimeoutStartTime.getTime() - idleTime;

      if (shouldCallOnIdleCbs) {
        callOnIdleCbs(overdueTimeMs);
      }
    }, idleTime);

    if (shouldCallOnActiveCbs) {
      callOnActiveCbs();
    }
  }

  function callOnIdleCbs(overdueTimeMs) {
    $rootScope.$applyAsync(() => {
      onIdleCallbacks.forEach((cb) => {
        if (!cb || !angular.isFunction(cb)) {
          return;
        }
        try {
          cb(overdueTimeMs);
        } catch (e) {
          $log.error(e);
        }
      });
    });
  }

  function callOnActiveCbs() {
    $rootScope.$applyAsync(() => {
      onActiveCallbacks.forEach((cb) => {
        if (!cb || !angular.isFunction(cb)) {
          return;
        }
        try {
          cb();
        } catch (e) {
          $log.error(e);
        }
      });
    });
  }

  function getIdleStatus() {
    return idleStatus;
  }

  /**
   * Subscribe of User Idle event
   * @param {function} cb callback
   * @return {function} unsubscribe function
   */
  function onIdle(cb) {
    if (!cb || !angular.isFunction(cb)) {
      return angular.noop;
    }
    onIdleCallbacks.push(cb);
    return function() {
      onIdleCallbacks = onIdleCallbacks
        .filter(item => item !== cb);
    };
  }

  /**
   * Subscribe of User Active event
   * @param {function} cb callback
   * @return {function} unsubscribe function
   */
  function onActive(cb) {
    if (!cb || !angular.isFunction(cb)) {
      return angular.noop;
    }
    onActiveCallbacks.push(cb);
    return function() {
      onActiveCallbacks = onActiveCallbacks
        .filter(item => item !== cb);
    };
  }

  function setIdleTimeout() {
    const webcoreAuthKeyPeriod = webcore.services.auth.apiKeyExpirePeriod || Infinity;
    const configIdleTime = config.getConfigByKey('environment.idleTimeout');
    idleTime = Math.min(webcoreAuthKeyPeriod, configIdleTime);

    if (brandedIdleTimeoutConfig) {
      const selectedOrg = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
      const availableOrgs = utils.getStorageItem(ALL_ORGS_LOCAL_STORAGE_KEY);
      if (selectedOrg && availableOrgs) {
        const brandName = utils.getBrandName(selectedOrg.id, availableOrgs);
        if (brandName && brandedIdleTimeoutConfig[brandName]) {
          idleTime = Math.min(webcoreAuthKeyPeriod, brandedIdleTimeoutConfig[brandName] * 1000);
        }
      }
    }
  }

  function initBrandedIdleTimeoutConfig() {
    return $q.when(webcore.services.systemProperties.getBrandedIdleTimeoutConfig())
      .then((config) => {
        brandedIdleTimeoutConfig = config;
        setIdleTimeout();
      });
  }

}
